// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "@rescript/react/src/React.bs.js";

let make = React.lazy_(() => import("./PaymentElementRenderer.bs.js").then(m => m.default));

export {
  make,
}
/* make Not a pure module */
